export default __webpack_public_path__ + "static/media/screenshot3_sm.08fdf5e3.jpg";